// import styled from "@emotion/styled";
import React , {useState} from "react";
import { TabContext, TabPanel } from "@mui/lab";
import TabList from "@mui/lab/TabList";
// import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ManageAddresses from "../../../components/ManageAddresses";
import OutlinedInput from "@mui/material/OutlinedInput";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  // Avatar,
  Box,
  Button,
  Paper,
  Stack,
  Tab,
  Grid,
  TextField,
  Typography,
  Drawer,
  Tooltip,
  InputAdornment ,
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

import dayjs from "dayjs";
import "dayjs/locale/pt";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

import { getUserEntity } from "../../../redux/features/authSlice";
import AddressCard from "./AddressCard";
import {
  setEndDate,
  setStartDate,
  setUpdateDonationDetail,
  updateDonation,
  setDonationTab,
  setSelectProductError,
  setAnimalEndDate,
  addCollectorInviteForDonation,
} from "../slice";
import {
  getMyActiveDonation,
  setMyActiveDonationsLimit,
  setMyActiveDonationsOffset,
  setMyActiveDonationsPage,
} from "../../DashBoardView/slice";
import { DonationStatus, EntityType, isCAActive } from "../../../common/enum";
import {
  setSnackbarMessage,
  setSnackbarOpen,
  setSnackbarSeverity,
} from "../../AdminView/adminSlice";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import CollectorInvitation from "../../CollectorInvitation";
import BlacklistEntity from "../../BlacklistEntity";
import { Label } from "@mui/icons-material";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import SearchIcon from "@mui/icons-material/Search";
const Address = ({ t }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const Item = styled(Paper)(({ theme }) => ({
  //   backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  //   ...theme.typography.body2,
  //   padding: theme.spacing(2),
  //   textAlign: "left",
  //   color: theme.palette.text.secondary,
  // }));

  const {
    auth,
    donationCart: {
      updateDonationDetail,
      startDate,
      endDate,
      donationType,
      selectProductError,
      animalEndDate,
      donationId,
      productList
    },
   
  } = useSelector((state) => state);
  const theme = useTheme();
  const matchesDown = useMediaQuery(theme.breakpoints.down("md"));
  
  const [dateValue, setDateValue] = React.useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const [startDateValue, setStartDateValue] = React.useState(null);
  const [reasonStartDate, setReasonStartDate] = React.useState(" ");
  const [errorStartDate, setErrorStartDate] = React.useState(false);
  const [reasonEndDate, setReasonEndDate] = React.useState(" ");
  const [errorEndDate, setErrorEndDate] = React.useState(false);
  const [animalEndDateValue, setAnimalEndDateValue] = React.useState(null);
  const [reasonAnimalEndDate, setReasonAnimalEndDate] = React.useState(" ");
  const [errorAnimalEndDate, setErrorAnimalEndDate] = React.useState(false);
  const [checked, setChecked] = React.useState("");
  const [isAnimalChecked, setIsAnimalChecked] = React.useState(false);
  const [isblaklistChecked, setIsBlacklist] = React.useState(true);
  const [remarkValue, setRemarkValue] = React.useState("");
  const [drawerState, setDrawerState] = React.useState(false);
  const [personName, setPersonName] = React.useState([]);
  const [confirmationDialog, setConfirmationDialog] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [modelContent, setModelContent] = React.useState("");
  const [selectedTab, setSelectedTab] = React.useState("1");
  const { address, entity } = auth.profile || {};
  const [selectedValue, setSelectedValue] = useState('');


  const [produtosCategorias, setProdutosCategorias] = useState([]);

 // const categoriasDisponiveis = ['Bebidas', 'Congelados', 'Frescos', 'Lacticíneos, cremes vegetais e ovos', 'Mercearia' , 'Refeições prontas'];
  //console.log(productList)
  const categoriasDisponiveis = productList.map(product => product.productGroup);
  const uniqueProductGroups = [...new Set(categoriasDisponiveis)];
  //console.log(categoriasDisponiveis)
  // const categoriasDisponiveis = [
  //   { value: 'valor1', label: 'Categoria1' },
  //   { value: 'valor2', label: 'Categoria2' },
  //   { value: 'valor3', label: 'Categoria3' },
  // ];
  function toLocalISOString(inputDate) {
    const date = inputDate instanceof Date ? inputDate : new Date(inputDate);
  
    if (isNaN(date)) {
      throw new Error('Invalid date');
    }
  
    const offsetMs = date.getTimezoneOffset() * 60000;
    const adjustedDate = new Date(date.getTime() - offsetMs);
    return adjustedDate.toISOString().slice(0, -1);
  }

  const handleChange = (event) => {
    setProdutosCategorias(event.target.value);
    var entradas = event.target.value.join(';')
    const payload = {
      ...updateDonationDetail,
      EventProductsInformation: entradas,
      isblocked : isblaklistChecked == true ? true : false
    };
   dispatch(setUpdateDonationDetail(payload));
  }
  const { userId } = auth.user || {};
  const setConfirmationValue = (val) => {
    setConfirmationDialog(val);
  };
  
  const setModalOpenValue = (val) => {
    setModalOpen(val);
  };
  const setModelContentValue = (val) => {
    setModelContent(val);
  };
  
  const setDeleteAddressIdValue = (val) => {
    setDeleteAddressId(val);
  };
  const [deleteAddressId, setDeleteAddressId] = React.useState("");
  
  const handleConsultar = React.useCallback(() => {
    setDrawerState(true);
  }, []);

  React.useEffect(() => {
    dispatch(getUserEntity(userId));
    setChecked(address[0].addressId)
    dispatch(setSelectProductError(false));
    const payload = {
      ...updateDonationDetail,
      donationId: donationId,
      status: DonationStatus.new,
      updatedBy: userId,
      addressId: address[0].addressId,
      isPublish: true,
    };
    dispatch(setUpdateDonationDetail(payload));
  }, [dispatch]);

  const startHandleChange = (newValue) => {
    setStartDateValue(newValue);
    if (!Number.isNaN(new Date(newValue).getTime()) && newValue !== null) {
      const payload = {
        ...updateDonationDetail,
        availableFromDate: toLocalISOString(newValue),
        isblocked : isblaklistChecked == true ? true : false
      };
      dispatch(setUpdateDonationDetail(payload));
      dispatch(setStartDate(false));
    }
  };

  
  // Lista de categorias disponíveis
  
  const endHandleChange = (newValue) => {
    setDateValue(newValue);
    if (!Number.isNaN(new Date(newValue).getTime()) && newValue !== null) {
      const payload = {
        ...updateDonationDetail,
        availableToDate: toLocalISOString(newValue),
        isblocked : isblaklistChecked == true ? true : false
      };
      dispatch(setUpdateDonationDetail(payload));
      dispatch(setEndDate(false));
    }
  };

  const endAnimalHandleChange = (newValue) => {
    setAnimalEndDateValue(newValue);
    if (!Number.isNaN(new Date(newValue).getTime()) && newValue !== null) {
      const payload = {
        ...updateDonationDetail,
        isAnimal: true,
        isblocked : isblaklistChecked == true ? true : false,
        consumedByDate: toLocalISOString(newValue),
      };

    const availableToDate = new Date(payload.availableToDate);
    const consumedByDate = new Date(payload.consumedByDate);

    const timeDifference = consumedByDate - availableToDate;
    const hoursDifference = timeDifference / (1000 * 60 * 60);
    const hasPassed24Hours = hoursDifference >= 1;

    if(hasPassed24Hours == false){
    //if(hasPassed24Hours ==  false){
      setErrorAnimalEndDate(true);
      setReasonAnimalEndDate(t("invalidDate"));
    }else{
      setErrorAnimalEndDate(false);
      setReasonAnimalEndDate(" ");
    }
      dispatch(setUpdateDonationDetail(payload));
      dispatch(setAnimalEndDate(false));
    }
  };

  const handleAnimalChange = (e) => {
    setIsAnimalChecked(e.target.checked);
    const payload = {
      ...updateDonationDetail,
      isblocked : isblaklistChecked == true ? true : false,
      isAnimal: e.target.checked,
    };
    dispatch(setUpdateDonationDetail(payload));
  };

  const handleblacklistChange = (e) => {
    setIsBlacklist(e.target.checked);
    const payload = {
      ...updateDonationDetail,
      isblocked: e.target.checked
    };
   dispatch(setUpdateDonationDetail(payload));
  };

  const addCollectorInvite = () => {
    const payload = {
      id: 0,
      donationId: donationId,
      collectorEntityId: personName.map((n) => n.entity.entityId),
      sentBy: entity?.entityId,
      status: "INVITED",
    };

    dispatch(addCollectorInviteForDonation(payload));
  };

  const onContinue = async () => {
    if(isAnimalChecked== true && errorAnimalEndDate === true || errorEndDate === true){
      enqueueSnackbar({
        message: "Datas inválidas",
        variant: "error",
      });
    }else{
      
      if (Object.keys(updateDonationDetail).length > 0) {
        // if(donationType != 'event'){
        //   updateDonationDetail["EventProductsInformation"] = null;
        // }
       
        if (updateDonationDetail["availableFromDate"] === undefined) {
          dispatch(setStartDate(true));
        } else if (updateDonationDetail["availableToDate"] === undefined) {
          dispatch(setEndDate(true));
        } else if (updateDonationDetail["addressId"] === undefined) {
          dispatch(setSelectProductError(true));
        } else if (
          updateDonationDetail["isAnimal"] === true &&
          updateDonationDetail["consumedByDate"] === undefined
        ) {
          dispatch(setAnimalEndDate(true));
        } else {
          if (updateDonationDetail["isAnimal"] === undefined) {
            const payload = {
              ...updateDonationDetail,
              isAnimal: false,
            };
            // if (updateDonationDetail["isblocked"] === undefined) {
            //   const payload = {
            //     ...updateDonationDetail,
            //     isblocked: false
            //   }
            // };
            dispatch(setUpdateDonationDetail(payload))
          }
          if (updateDonationDetail["isblocked"] === undefined) {
            const payload = {
              ...updateDonationDetail,
              isblocked: true
            };
           
            dispatch(setUpdateDonationDetail(payload))
          }
          addCollectorInvite();
          dispatch(updateDonation(updateDonationDetail))
            .unwrap()
            .then(() => {
              navigate("/dashboard");
              const data = {
                limit: 10,
                offset: 0,
                status: DonationStatus.new,
              };
              if (entity.entityType === EntityType.donor) {
                data["entityId"] = entity.entityId;
              }
              dispatch(getMyActiveDonation(data));
              dispatch(setMyActiveDonationsLimit(10));
              dispatch(setMyActiveDonationsOffset(0));
              dispatch(setMyActiveDonationsPage(1));
              if(donationType == 'event'){
                enqueueSnackbar({
                  message: "Evento criado com sucesso",
                  variant: "success",
                });
              }else{
                enqueueSnackbar({
                  message: t("donationCreatedSuccessfully"),
                  variant: "success",
                });
              }
             
              dispatch(setDonationTab("product"));
            })
            .catch((err) => {
              // alert("Failed to Update donation Info");
              
              enqueueSnackbar({
                message: t("failedToUpdateDonation"),
                variant: "error",
              });
            });
        }
      } else {
        if(donationType == 'event'){
          enqueueSnackbar({
            message: "Selecione a morada e a data de recolha, para criar o evento",
            variant: "error",
          });
        }else{
          enqueueSnackbar({
            message: "Selecione a morada e a data de recolha, para criar a doação",
            variant: "error",
          });
        }
       
        // dispatch(setRecolhaDate(true));
      }
    }
    
  };
 
  React.useEffect(() => {
    if (checked.length > 0) {
      dispatch(setSelectProductError(false));
    }
  }, [checked, dispatch]);

  return (
    <>
      <Stack padding={"2%"} spacing={3} marginRight={3}>
        <Typography fontSize={"subheading"} fontWeight={"bold"}>
          {t("createDonationAddressHeading")}
        </Typography>

        <Paper>
          <Box sx={{ width: "100%", typography: "body1", padding: "10px" }}>
            <TabContext value={selectedTab}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  // onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  <Tab label={"Os meus endereços"} value="1" onClick={() => setSelectedTab("1")} />
                  <Tab label={"Outro endereço"} value="2" onClick={() => setSelectedTab("2")} />
                </TabList>
              </Box>
              <TabPanel value="1">
                <Stack>
                  <Grid container xs={12}>
                    {selectProductError && (
                      <Typography variant="body1" color="error">
                        {t("selectAddressError")}
                      </Typography>
                    )}
                    {address &&
                      address.map((addressItem) => (
                        <AddressCard
                          item={addressItem}
                          key={addressItem.id}
                          checked={checked}
                          setChecked={setChecked}
                        />
                      ))}
                  </Grid>
                  {/* <Item>
                    <Box>
                      Other Address
                      <Grid container>
                      <Grid xs={10}>
                        My Address2
                      </Grid>
                      <Grid xs={2}>
                      <Checkbox
                        defaultChecked
                        sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                      />
                      </Grid>
                      </Grid>
                    </Box>
                  </Item> */}
                </Stack>
              </TabPanel>
              <TabPanel value="2" className="panelMorada">
              <Typography>Introduza um novo local de entrega. Após confirmação poderá selecionar a morada no tabulador "Os meus endereços".<br></br>Este endereço será também adicionado ao seu perfil.</Typography>
              <ManageAddresses
                    t={t}
                    address={address}
                    setConfirmationDialog={setConfirmationValue}
                    setModalOpen={setModalOpenValue}
                    setModelContent={setModelContentValue}
                    setDeleteAddressId={setDeleteAddressIdValue}
                  />
              </TabPanel>
            </TabContext>
          </Box>
        </Paper>
        <Paper>
          <Box sx={{ width: "100%", typography: "body1", padding: "10px" }}>
            <TabContext value={"1"}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  // onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  <Typography fontWeight={"bold"}>
                    {t("collectionCharacteristics")}
                  </Typography>
                </TabList>
              </Box>
              <TabPanel value="1">
                <Grid
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      display: "flow",
                      alignItems: "center",
                    }}
                  >
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale={"pt"}
                    >
                      <DateTimePicker
                       dayOfWeekFormatter={(day) => {
                        const map = {
                          "2ª": "S",  // Segunda
                          "3ª": "T",  // Terça
                          "4ª": "Q",  // Quarta
                          "5ª": "Q",  // Quinta
                          "6ª": "S",  // Sexta
                          "Sa": "S",  // Sábado
                          "Do": "D",  // Domingo
                        };
                        return map[day] ?? day;
                      }}
                        disablePast
                        defaultValue={dayjs()}
                        label={t("startDate")}
                        ampm={false}
                        value={startDateValue}
                        minDateTime={dayjs()}
                        onChange={startHandleChange}
                        inputFormat="DD/MM/YYYY HH:mm"
                        onError={(reason, value) => {
                          if (reason) {
                            setErrorStartDate(true);
                            setReasonStartDate(t("invalidDate"));
                          } else {
                            setErrorStartDate(false);
                            setReasonStartDate(" ");
                          }
                        }}
                        renderInput={(props) => (
                          <TextField
                            {...props}
                            error={
                              errorStartDate === true || startDate === true
                                ? true
                                : false
                            }
                            sx={{
                              mr: 1,
                            }}
                            helperText={
                              
                              startDate
                                ? donationType == 'event' ? "Selecione o evento disponível a partir da data" : "Selecione a doação disponível a partir da data"
                                : reasonStartDate
                            }
                          />
                        )}
                      />
                    </LocalizationProvider>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale={"pt"}
                    >
                      <DateTimePicker
                       dayOfWeekFormatter={(day) => {
                        const map = {
                          "2ª": "S",  // Segunda
                          "3ª": "T",  // Terça
                          "4ª": "Q",  // Quarta
                          "5ª": "Q",  // Quinta
                          "6ª": "S",  // Sexta
                          "Sa": "S",  // Sábado
                          "Do": "D",  // Domingo
                        };
                        return map[day] ?? day;
                      }}
                        disablePast
                        label={t("endDate")}
                        ampm={false}
                        value={dateValue}
                        sx={{ mr: 1 }}
                        // minDate={startDateValue}
                        minDateTime={dayjs(startDateValue).add(1, 'minute')}
                        onChange={endHandleChange}
                        inputFormat="DD/MM/YYYY HH:mm"
                        onError={(reason, value) => {
                          if (reason) {
                            setErrorEndDate(true);
                            setReasonEndDate(t("invalidDate"));
                          } else {
                            setErrorEndDate(false);
                            setReasonEndDate(" ");
                          }
                        }}
                        renderInput={(props) => (
                          <TextField
                            {...props}
                            error={
                              errorEndDate === true || endDate === true
                                ? true
                                : false
                            }
                            helperText={
                              endDate
                                ? donationType == 'event' ? "Selecione o evento disponível até o momento" : "Selecione a doação disponível até o momento"
                                : reasonEndDate
                            }
                          />
                        )}
                      />
                    </LocalizationProvider>
                    <Box sx={{display:"flex"}}>
                      {/* start Alimentação animal */}
                      {isCAActive == true && (
                        <FormGroup sx={{display:"block"}}>
                          <FormControlLabel
                            // required
                            control={
                              <Checkbox
                                checked={isAnimalChecked}
                                onChange={handleAnimalChange}
                              />
                            }
                            label={t("alternativeAnimalChannel")}
                            sx={{mb: 2 , marginRight:"4px"}}
                          />
                          <Tooltip
                            title={"(ex.: Canis/Gatis, Zoos) Caso não seja possível canalizar para a alimentação humana a totalidade da sua doação, ao selecionar esta opção do canal alternativo as entidades recetoras da alimentação animal irão receber uma notificação após o término da recolha que definiu para a alimentação humana. Adicionalmente, deve definir a data e horário final para a recolha destinada à alimentação animal (ex.: Canis/Gatis, Zoos), tendo presente que terá de estabelecer o horário final de recolha para estas entidades com pelo menos 1 hora depois do término da recolha definido para a alimentação humana."}>
                            <InfoOutlinedIcon sx={{mb:2 , color:"#37B34A" ,  marginRight:"9px"}}/>
                          </Tooltip>
                        </FormGroup>
                      )}
                    
                    {/* end Alimentação animal */}
                    {isAnimalChecked && (
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale={"pt"}
                      >
                        <DateTimePicker
                         dayOfWeekFormatter={(day) => {
                            const map = {
                              "2ª": "S",  // Segunda
                              "3ª": "T",  // Terça
                              "4ª": "Q",  // Quarta
                              "5ª": "Q",  // Quinta
                              "6ª": "S",  // Sexta
                              "Sa": "S",  // Sábado
                              "Do": "D",  // Domingo
                            };
                            return map[day] ?? day;
                          }}
                          disablePast
                          label={t("endDate")}
                          ampm={false}
                          value={animalEndDateValue}
                          sx={{ mr: 1 }}
                          // minDate={startDateValue}
                          //minDateTime={dayjs(dateValue).add(1, "day")}
                          minDateTime={dayjs(dateValue).add(1, "hour")}
                          onChange={endAnimalHandleChange}
                          inputFormat="DD/MM/YYYY HH:mm"
                          
                          renderInput={(props) => (
                            <TextField
                              {...props}
                              error={
                                errorAnimalEndDate === true ||
                                animalEndDate === true
                                  ? true
                                  : false
                              }
                              helperText={
                                animalEndDate
                                  ? "Selecione a doação disponível até o momento"
                                  : reasonAnimalEndDate
                              }
                            />
                          )}
                        />
                      </LocalizationProvider>
                    )}
                    </Box>
                    
                  </Box>
                  <FormGroup
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "wrap",
                      marginBottom: "16px",
                      width:"100%"
                    }}
                  >
                    {donationType == 'event' ?
                    <FormControlLabel
                      // required
                      control={
                        <Checkbox
                          checked={isblaklistChecked}
                          onChange={handleblacklistChange}
                        />
                      }
                      label={'Evento não disponível para entidades excluídas'}
                      sx={{ my: 2 , marginTop:"0px" , marginBottom:"0px" }}
                    /> 
                    
                    :
                    <FormControlLabel
                      // required
                      control={
                        <Checkbox
                          checked={isblaklistChecked}
                          onChange={handleblacklistChange}
                        />
                      }
                      label={t("donationNotAviableForExcludedEntities")}
                      sx={{ my: 2 , marginTop:"0px" , marginBottom:"0px"}}
                    />}
                    
                    <Button
                      sx={{
                       
                        fontWeight: 600,
                        textDecoration: "underline",
                        color: "#1c727e",
                        p: "0px !important",
                        "&:hover": {
                          backgroundColor: "transparent",
                          textDecoration: "underline",
                        },
                        borderRadius:"4px"
                      }}
                      onClick={handleConsultar}
                    >
                      {t("consult")}
                    </Button>
                  </FormGroup>
                  {donationType == 'event' &&
                    <FormControl sx={{ width: 1, marginBottom: "20px" }}>
                    <InputLabel id="demo-multiple-chip-label" sx={{ backgroundColor: "white" }}>
                      {'Produtos eventualmente disponíveis'}
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-chip-label"
                      id="demo-multiple-chip"
                      multiple
                      fullWidth
                      value={produtosCategorias}
                      onChange={handleChange}
                      input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                      renderValue={(selected) => (
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 0.5,
                            alignItems: "center",
                          }}
                        >
                          {selected.map((item, index) => (
                            <React.Fragment key={index}>
                              <Typography variant="subtitle1" fontFamily={"Poppins"}>
                                {item}
                              </Typography>
                              {index < selected.length - 1 && <span>; </span>}
                            </React.Fragment>
                          ))}
                          {/* {selected.length > 1 && (
                            <Chip
                              label={`+${selected.length - 1}`}
                              sx={{
                                backgroundColor: "#E4F2E8",
                                color: "#1B727E",
                                m: "5px",
                                "& .MuiChip-label": { fontWeight: "bold" },
                              }}
                            />
                          )} */}
                        </Box>
                      )}
                    >
                      {uniqueProductGroups.map((categoria) => (
                        <MenuItem key={categoria} value={categoria}>
                          {categoria}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  }
                  <span style={{ width: "100%" }}>
                    <CollectorInvitation
                      personName={personName}
                      entityUpdate={userId}
                      isBlacklist={isblaklistChecked}
                      setPersonName={setPersonName}
                      t={t}
                    />
                  </span>
                </Grid>
                <Grid style={{ marginTop: "30px" }}>
                    <TextField
                      style={{ width: "100%" }}
                      label={t("remarks")}
                      multiline
                      minRows={4}
                      value={remarkValue}
                      onChange={(e) => {
                        setRemarkValue(e.target.value);
                        const payload = {
                          ...updateDonationDetail,
                          note: e.target.value,
                          isblocked: isblaklistChecked == true ? true : false,
                        };
                        dispatch(setUpdateDonationDetail(payload));
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end" sx={{ alignSelf: "flex-start", mt: 1 }}>
                          <Tooltip
                            title={
                              <div style={{ maxWidth: 400 }}>
                                <div style={{ marginBottom: 8 }}>
                                  Utilize este campo para partilhar informações relevantes sobre o(s) produto(s) que está a doar, como:
                                </div>
                                <ul style={{ paddingLeft: 20, margin: 0 }}>
                                  <li>Indicação da necessidade do recetor levar caixas/embalagens/sacos para a recolha;</li>
                                  <li>Condições de conservação dos produtos;</li>
                                  <li>Prazo de validade (se aplicável);</li>
                                  <li>Especificar as quantidades disponíveis de forma mais detalhada;</li>
                                  <li>Condições específicas de recolha (como os horários disponíveis para a recolha - por exemplo, dias úteis das 15h às 19h);</li>
                                  <li>Outras observações que possam ser úteis à entidade beneficiária</li>
                                </ul>
                              </div>
                            }
                          >
                            <InfoOutlinedIcon sx={{ color: "#37B34A", cursor: "pointer" }} />
                          </Tooltip>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

              </TabPanel>

              {/* <TabPanel value="2">Item Two</TabPanel> */}
            </TabContext>
            {matchesDown && (
        <Button
        size="large"
        variant="contained"
        onClick={() => onContinue()}
        endIcon={<CheckCircleOutlineOutlinedIcon fontSize="16px" />}
        sx={{borderRadius:"4px"}}
      >
        <Typography variant="bold">Finalizar</Typography>
      </Button>
      )}
          </Box>
        </Paper>
        {donationType === "event" && (
          <Box
            sx={{
              width: 1,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              size="large"
              variant="contained"
              onClick={() => onContinue()}
              endIcon={<CheckCircleOutlineOutlinedIcon fontSize="16px" />}
              sx={{borderRadius:"4px"}}
            >
              <Typography variant="bold">Finalizar</Typography>
            </Button>
          </Box>
        )}
      </Stack>
      <Drawer
        anchor={"right"}
        open={drawerState}
        PaperProps={{
          sx: { width: "50%" },
        }}
        onClose={() => {
          setDrawerState(false);
        }}
      >
        <Button
          sx={{
            position: "fixed",
            right: "51%",
            top: 10,
            zIndex: 1,
            minWidth: 0,
            borderRadius: "4px",
            padding: "4px",
            backgroundColor: "#ffc3c3",
            "&:hover": {
              backgroundColor: "#ffc3c3",
            },
          }}
          onClick={() => setDrawerState(false)}
        >
          <CloseOutlinedIcon color="error" />
        </Button>
        <BlacklistEntity t={t} />
      </Drawer>
    </>
  );
};

export default Address;
